import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { UnauthenticatedModule } from './pages/unauthenticated/unauthenticated.module';
import { AuthenticatedModule } from './pages/authenticated/authenticated.module';
import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { SharedModule } from './shared/shared.module';
import { AuthInterceptor } from './shared/interceptors/auth.interceptor';
import { HeaderInterceptor } from './shared/interceptors/header.interceptor';
import { registerLocaleData } from '@angular/common';
import { PlatformModule } from '@angular/cdk/platform';
import localeEn from '@angular/common/locales/en';
import localeFr from '@angular/common/locales/fr';

// Register the locales
registerLocaleData(localeEn, 'en');
registerLocaleData(localeFr, 'fr');

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './i18n/', '.json');
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    UnauthenticatedModule,
    AuthenticatedModule,
    BrowserAnimationsModule,
    SharedModule,
    PlatformModule,
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
      isolate: false,
    }),
  ],
  providers: [provideHttpClient(withInterceptors([AuthInterceptor, HeaderInterceptor])), { provide: LOCALE_ID, useValue: 'en-GB' }],
  bootstrap: [AppComponent],
})
export class AppModule {}
